import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

/**
 * Runs a callback whenever url path changes.
 * For comparison with new url a url at first render time is used.
 */
export const useRouterOnPathChange = (callBack: () => void): void => {
  const pathName = usePathname()
  const pathNameInitial = useRef<string>(pathName)

  useEffect(() => {
    if (pathNameInitial.current !== pathName) {
      callBack()
    }
  }, [pathName, pathNameInitial, callBack])
}
